import { InstallationRefusal } from '@core/helpers/installation-refusal.helper';

export type DetailsRefusalPlace = 'location' | 'dialog';

export interface DetailsRefusal {
  place: DetailsRefusalPlace;
  messageKey: string;
  // What the dialog was opened on has changed underneath it, so the page must read it again.
  stale: boolean;
  // The location has no coordinates, which only its own page can fix.
  linksToLocation: boolean;
}

const KEY_PREFIX = 'installations.details.errors.';

const LOCATION_NOT_FOUND = 'Location not found';

function refusal(
  place: DetailsRefusalPlace,
  key: string,
  { stale = false, linksToLocation = false } = {},
): DetailsRefusal {
  return { place, messageKey: KEY_PREFIX + key, stale, linksToLocation };
}

// Explains a refused create or edit in the dialog that sent it. A 422 or an unknown reason means
// the request itself was wrong, which the user cannot fix, so it reads like any other failure to
// save.
export function detailsRefusal(
  action: 'create' | 'edit',
  { status, reason }: InstallationRefusal,
): DetailsRefusal {
  if (status === 409 && reason === 'location_without_coordinates') {
    return refusal('location', 'locationWithoutCoordinates', { linksToLocation: true });
  }
  if (status === 409 && reason === 'location_without_partner') {
    return refusal('location', 'locationWithoutPartner');
  }
  if (status === 400 && reason === 'unknown_preset') {
    return refusal('dialog', 'unknownPreset');
  }
  if (status === 409 && reason === 'installation_not_active') {
    return refusal('dialog', 'installationNotActive', { stale: true });
  }
  if (status === 401 || status === 403) {
    return refusal('dialog', action === 'create' ? 'notAllowedToCreate' : 'notAllowedToEdit');
  }
  if (status === 404 && reason === LOCATION_NOT_FOUND) {
    return refusal('location', 'locationNotFound');
  }
  if (status === 404) {
    return refusal('dialog', 'gone', { stale: true });
  }
  return refusal('dialog', 'notSaved');
}
